import angular from 'angular';

let inject = ['$scope', '$uibModalInstance', 'SessionService','$timeout', '$state', 'cartData', 'TunnelService', 'shCtrl'];

class ModalDriversRegisterController {

    constructor($scope, $uibModalInstance, SessionService,$timeout, $state, cartData, TunnelService, shCtrl) {
        this.cartData = cartData;
        this.TunnelService = TunnelService;
        this.directions = [];
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.$uibModalInstance = $uibModalInstance;
        this.$state = $state;
        this.SessionService = SessionService;
        this.newDriver = {};
        this.drivers = [];
        this.showError = null;
        this.showSuccess = null;
        this.showErrorAlone = null;
        this.shCtrl = shCtrl;
        this.cartId=null;
    }

    $onInit() {
        this.continueSaveDriver = false;
        this.savingDriver=false;

        this.getCartDrivers();
        this.cartId = this.SessionService.get('cartId');

        if(this.drivers.length == 10){
            this.showErrorAlone = "No es posible asignar más de 10 conductores para el mismo pedido";
        }
    }

    saveDriver() {
        if (this.driverForm.$valid) {
            this.savingDriver=true;
            this.showErrorAlone = '';


            let userId = '';
            try {
                userId = this.shCtrl.globals.currentUser.userId;
            }
            catch (e) {}

            let flagDriver = true;
            let countDrivers = 0;

            angular.forEach(this.drivers, (value, key) => {
                countDrivers++;
                if(this.newDriver.cedula == value.conductor_documento){
                    flagDriver = false;
                    this.showErrorAlone += "Ya existe un conductor agendado con la cédula ingresada. ";
                    this.savingDriver =false;
                    this.continueSaveDriver = false;
                }

                if(angular.uppercase(this.newDriver.placa) == angular.uppercase(value.placa_vehiculo)){
                    flagDriver = false;
                    this.showErrorAlone += "Ya existe un conductor agendado con la placa de vehículo ingresada. ";
                    this.savingDriver =false;
                    this.continueSaveDriver = false;
                }
            });

            if(this.drivers.length  >= 10){
                flagDriver = false;
                this.showErrorAlone = "No es posible asignar más de 10 conductores para el mismo pedido";
                this.savingDriver =false;
                this.continueSaveDriver = false;
            }


            if (flagDriver) {

                let data = {
                    driver: this.newDriver,
                    cartId: this.cartId
                };

                this.TunnelService.saveDriver(data).then((response) => {

                    if (response.error) {
                        this.showErrorAlone = response.message;
                        this.savingDriver =false;
                        this.continueSaveDriver = false;
                    } else {
                        this.showSuccess = response.message;
                        this.continueSaveDriver=true;
                    }

                });

            }

        } else {
            this.driverForm.cedula.$setDirty();
            this.driverForm.nombre.$setDirty();
            this.driverForm.placa.$setDirty();
            this.driverForm.telefono.$setDirty();
        }
    }

    redirectAllDirections(){
        this.$state.go('home.address');
        this.$uibModalInstance.dismiss('cancel');
    }

    cancel() {
        this.$uibModalInstance.dismiss('cancel');
    }

    resetModal(){
        this.showSuccess = null;
        this.savingDriver =false;
        this.continueSaveDriver = false;
        this.newDriver = {};
        this.getCartDrivers();

        if(this.drivers.length == 10){
            this.showErrorAlone = "No es posible asignar más de 10 conductores para el mismo pedido";
        }
    }


    getCartDrivers(){
        let cartId = this.SessionService.get('cartId');

        this.TunnelService.getCanastaConductores({cartId: cartId}).then((response) => {

            if (response.error) {

            } else {
                this.drivers = response.data;
                console.log(this.drivers)
            }

        });
    }

}

ModalDriversRegisterController.$inject = inject;

export default ModalDriversRegisterController;



/** WEBPACK FOOTER **
 ** ./www/components/tunnel/modal-drivers-register/modal-drivers-register.controller.js
 **/